import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_BUILDING',
  GET: 'GET_BUILDING',
  EDIT: 'EDIT_BUILDING',
  DELETE: 'DELETE_BUILDING',
  REMOVE_IMAGE: 'REMOVE_IMAGE',
  UPLOAD_IMAGE: 'UPLOAD_IMAGE',
  EXPORT_REPORT: 'EXPORT_REPORT',
  CLEAR_ERROR: 'CLEAR_ERROR_BUILDING',
};

export const searchBuildingByText = (text, page = 0) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = null;
  const filtered = text;
  const isPublic = null;
  const buildingId = null;
  return searchBuilding(pageSize, page, sorted, filtered, isPublic, buildingId);
};

export const searchBuilding = (pageSize, page, sorted, filtered, isPublic) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_BUILDING,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id).join(',')
        : null,
      is_public: isPublic,
    },
  });
};

export const listBuilding = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchBuilding(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const getBuilding = buildingId => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_BUILDING}${buildingId}/`,
    }).catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const editBuilding = (buildingId, params) => {
  const {
    name,
    image,
    building_type_id,
    description,
  } = params;

  const formData = new FormData();
  if (name) formData.set('name', name);
  if (image) formData.set('image', image);
  if (building_type_id) formData.set('building_type_id', building_type_id);
  if (typeof(description) === 'string') formData.set('description', description);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_BUILDING}${buildingId}/`,
      data: formData,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteBuilding = (buildingId, params) => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_BUILDING}${buildingId}/`,
      data: params,
    })
      .then(() => ({ id: buildingId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const exportReport = (buildingId) => {
  return {
    type: ACTION.EXPORT_REPORT,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_BUILDING}${buildingId}/rml/`,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const clearErrorBuilding = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/redux/buildings/buildings_actions.js